var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestaurant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#e8eaed",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300-100v-361.38q-46.38-7.08-78.58-42.54-32.19-35.46-32.19-86.85V-860h40v269.23H300V-860h40v269.23h70.77V-860h40v269.23q0 51.39-32.19 86.85-32.2 35.46-78.58 42.54V-100h-40Zm369.23 0v-320h-98.46v-260q0-66.85 37.73-118.42 37.73-51.58 100.73-60.04V-100h-40Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurant);
export default __webpack_public_path__ + "static/media/restaurant.3f18dfe059a9fa6ea5321e08cada3d6c.svg";
export { ForwardRef as ReactComponent };